export const handleZoeRedirect = (zoeUrl, answer, aacri, aaci) => {
    const url = new URL(zoeUrl || window.location.origin);
    const originUrl = new URL(window.location.href);
    const allowedParams = ['gclid', 'tag'];

    if (answer) {
        url.searchParams.append('first_question', answer);
    }

    if (aacri?.value) {
        url.searchParams.append('aacri', aacri.value);
    }

    if (aaci?.value) {
        url.searchParams.append('aaci', aaci.value);
    }

    url.searchParams.append('origin', originUrl);

    originUrl.searchParams.forEach((value, key) => {
        if (allowedParams.includes(key)) {
            url.searchParams.append(key, value);
        }
    });

    window.location.href = url.href;
};
